import { atomWithReset } from 'jotai/utils';

import { type AlertBannerType } from '@soluto-private/mx-asurion-ui-react';

export type AlertBanner = {
  bannerType: AlertBannerType;
  message: string;
  skipResetOnPaths?: string[];
};

export const alertBannerAtom = atomWithReset<AlertBanner | undefined>(
  undefined
);
